import { initialState } from "./initialState";
import * as types from "./types";

// const initialState = {
//   data: null,
//   loader: false,
//   error: false,
//   success: false,
//   message: "",
// };

export default function vizReducer(state = initialState.apiStatus, action) {
  switch (action.type) {
    case types.FETCH_PLOT_STATE:
      return {
        ...state,
        plot: action.payload,
      };

    // case types.CLEAR_PLOT_STATE:
    //   return {
    //     ...state,
    //     plot: action.payload,
    //   };

    case types.FETCH_PRODUCT_SITES_LIST:
      return {
        ...state,
        productsAndSitesList: action.payload,
      };

    case types.FETCH_PARAMETER_LIST:
      return {
        ...state,
        parameterNamesList: action.payload,
      };

    case types.FETCH_FILTERED_BATCH_LIST:
      return {
        ...state,
        filteredBatchList: action.payload,
      };

    case types.FETCH_SAVED_VIZ_LIST_REQUEST:
      return { ...state, savedVizList: action.payload };

    case types.FETCH_FOLDER_REQUEST:
      return { ...state, folderList: action.payload };

    case types.FETCH_SAVED_VIZ_DETAILS:
      return {
        ...state,
        savedVizDetails: action.payload,
      };



    default:
      return state;
  }
}
